import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Phone, Mail, MapPin, Car } from 'lucide-react';

const LOGO_WHITE_BG = "https://customer-assets.emergentagent.com/job_quick-cab-booking/artifacts/zydgwvt1_13cabsbook%20logo%20short.png";

export const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleBookClick = (e) => {
    e.preventDefault();
    
    if (location.pathname === '/') {
      const bookingSection = document.getElementById('booking');
      if (bookingSection) {
        bookingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const bookingSection = document.getElementById('booking');
        if (bookingSection) {
          bookingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <footer className="bg-secondary text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & About */}
          <div className="md:col-span-2">
            <img src={LOGO_WHITE_BG} alt="13cabsbook" className="h-14 mb-4" />
            <p className="text-gray-400 leading-relaxed max-w-md">
              Melbourne's trusted taxi service. Professional drivers, competitive rates, 
              and 24/7 availability across Victoria. Your comfort and safety are our priority.
            </p>
            <div className="flex items-center gap-4 mt-4">
              <Car className="w-5 h-5 text-primary" />
              <span className="text-sm text-gray-400">Proudly serving Melbourne</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-bold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={handleBookClick}
                  className="text-gray-400 hover:text-primary transition-colors text-left"
                >
                  Book a Taxi
                </button>
              </li>
              <li>
                <Link to="/fleet" className="text-gray-400 hover:text-primary transition-colors">
                  Our Fleet
                </Link>
              </li>
              <li>
                <Link to="/airport-transfers" className="text-gray-400 hover:text-primary transition-colors">
                  Airport Transfers
                </Link>
              </li>
              <li>
                <Link to="/corporate" className="text-gray-400 hover:text-primary transition-colors">
                  Corporate Services
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-gray-400 hover:text-primary transition-colors">
                  Events & Sports
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-primary transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-bold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-gray-400">
                <Phone className="w-4 h-4 text-primary flex-shrink-0" />
                <a href="tel:1300096685" className="hover:text-primary transition-colors">
                  1300 096 685
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-400">
                <Mail className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                <a href="mailto:13cabsbook.com.au@gmail.com" className="hover:text-primary transition-colors text-sm break-all">
                  13cabsbook.com.au@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <MapPin className="w-4 h-4 text-primary flex-shrink-0" />
                <span>Melbourne, Victoria</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="border-t border-white/10 mt-8 pt-8">
          <div className="flex flex-col items-center gap-3">
            <p className="text-xs text-gray-500 uppercase tracking-widest">We Accept</p>
            <img 
              src="https://customer-assets.emergentagent.com/job_quickcabvic/artifacts/6pxagn7b_image.png" 
              alt="We accept Visa, Discover, Google Pay, Apple Pay, Mastercard, American Express, PayPal"
              className="h-8 md:h-10 w-auto max-w-full object-contain"
            />
          </div>
        </div>

        {/* Copyright Bar */}
        <div className="border-t border-white/10 mt-6 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} 13cabsbook.com.au - Melbourne Taxi Company. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-sm text-gray-500">
            <Link to="/contact" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="/contact" className="hover:text-primary transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
